import React from 'react';
import { Typography } from '@cherre-frontend/ui';

interface ProviderSettingsFormatPreviewProps {
  value: string;
  alignSelf?: 'center' | 'top';
}

export const ProviderSettingsFormatPreview = ({
  alignSelf = 'center',
  value,
}: ProviderSettingsFormatPreviewProps) => {
  return (
    <Typography
      variant='body2'
      fontWeight='bold'
      alignSelf={alignSelf}
      justifySelf='end'
    >
      Format Preview:{' '}
      <Typography
        component='span'
        variant='inherit'
        color='primary'
        paddingLeft={1.5}
      >
        {value}
      </Typography>
    </Typography>
  );
};
